import { Event } from '@/app/event-stream';

export const CompetenceUpdatedEventName = 'competence-updated' as const;

export type CompetenceEvent = Event<typeof CompetenceUpdatedEventName, {}>;
